import { useState, useRef, useEffect, useContext } from 'react'
import { WizardContext } from '../WizardContext'
import { BlobAPI } from '../api/BlobAPI'
import { CampaignAPI } from '../api/CampaignAPI'
import { DeterminateLoading } from './ui/DeterminateLoading'
import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import Snackbar from '@mui/joy/Snackbar'
import Typography from '@mui/joy/Typography'
import { Link } from 'react-router-dom'

export const VideoCampaignUploader = ({ onStatusChanged }) => {
    const [progress, setProgress] = useState(0)
    const [isSnackOpen, setIsSnackOpen] = useState(false)
    const {
        context: {
            title,
            file,
            targetClipLength,
            enableCaptions,
            removeSilence,
        },
    } = useContext(WizardContext)
    const key = useRef()

    useEffect(() => {
        BlobAPI.getPresignedUrl(file.name, file.type).then((response) => {
            key.current = response.data.data.fields.key
            BlobAPI.uploadBlob(response.data.data, file, (progressEvent) => {
                setProgress(
                    Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    )
                )
            }).then((uploadResponse) => {
                const url = `${uploadResponse.request.responseURL}${key.current}`
                CampaignAPI.createVideoCampaign(
                    title,
                    url,
                    targetClipLength,
                    enableCaptions,
                    removeSilence
                )
                    .then((response) => {
                        console.log('create video campaign response', response)
                        onStatusChanged(response.data)
                    })
                    .catch((err) => {
                        if (err.response.status == 429) {
                            console.log(
                                'User has exceeded uses for video clips'
                            )
                            setIsSnackOpen(true)
                        }
                    })
            })
        })
    }, [])

    return (
        <>
            <DeterminateLoading value={progress} message="Uploading Video..." />
            <Snackbar
                variant="soft"
                color="danger"
                open={isSnackOpen}
                endDecorator={
                    <Link to="/merchant/settings" reloadDocument>
                        <Button size="sm" variant="soft" color="danger">
                            Upgrade
                        </Button>
                    </Link>
                }
            >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography level="h4">Trial Usage Reached</Typography>
                    <Box>You've reached the trial limit to create clips.</Box>
                    <Box>Upgrade to Pro to create more content!</Box>
                </Box>
            </Snackbar>
        </>
    )
}
